import React, { useState } from 'react';
import './Card.css';

import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import nlp from '../../assets/nlp.jpg'
import vehicle from '../../assets/vehicle.jpg'
import defence from '../../assets/defence.jpg'
import ecommerce from '../../assets/e-commerce.jpg'
import genAI from '../../assets/genAI.jpg'
const App = () => {
  const flipCardData = [
    { image: nlp, title: 'Natural Language Processing', info: 'NLP is a powerful technology that connects human language and computer understanding. It enables businesses to analyze text data, automate customer support, and optimize targeted marketing. AI-driven NLP solutions offer valuable insights, improved customer interactions, and streamlined workflows, keeping businesses competitive.' },
    { image: vehicle, title: 'Autonomous vehicles', info: 'AI and Machine Learning revolutionize transportation with autonomous vehicles. They navigate complex environments, enhance safety, and improve efficiency. Through data processing and continuous learning, they detect traffic conditions and adapt to new challenges. Autonomous vehicles have the potential to transform transportation by reducing congestion and minimizing accidents.' },
    { image: defence, title: 'AI in Defense', info: "AI and Machine Learning are transforming defense systems, bolstering national security. These technologies improve decision-making, resource allocation, and autonomous systems. AI-driven solutions analyze large datasets, predict threats, and enable real-time monitoring. This integration strengthens security and enhances military response to emerging challenges." },
    { image: ecommerce, title: 'Retail and eCommerce', info: 'AI and Machine Learning transform retail and eCommerce. They offer personalized experiences, optimize inventory management, and enable dynamic pricing. Advanced algorithms analyze customer data and predict demand for stocked products. AI-powered chatbots and fraud detection enhance support and security.' },
    { image: genAI, title: 'Generative AI', info: "Using GenAi we provide some special functionality like LLM, Automate Advertising, Claim intelligence, Trends Detection, Personal Ai Assistance, Image Generation, and GPT Solutions." },
  ];

  const FlipCard = ({ image, title, info }) => {
    const [isFlipped, setIsFlipped] = useState(false);

    const handleFlip = () => {
      setIsFlipped(!isFlipped);
    };
    return (
      <div className="main-container">
        <div
          className={`flip-card ${isFlipped ? 'flipped' : ''}`}
          onClick={handleFlip}
        >
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <div>
                <img src={image} alt={title} />
                <div className='card-title'>
                  <DoubleArrowIcon style={{ paddingTop: 8, color: 'white' }}></DoubleArrowIcon>
                  <span>{title}</span>
                </div>
              </div>
              <div className="read-more">
                <span>Read More...</span>
              </div>
            </div>
            <div className="flip-card-back">
              <div className='back-container'>

                <span style={{ fontSize: 20 }}>{title}</span>
                <hr />
                <div style={{ display: 'flex' }}>
                  <span className='back-info'>&nbsp;&nbsp;&nbsp;&nbsp;{info}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className='whole-body'>
        {/* <img src={background} style={{width:'100%'}} alt="" /> */}
        <span className='title-span'>Our Services</span>
        <span className='second-span'>This are the services which we provide</span>
        <div className="grid-container">
          {flipCardData.map((card, index, info) => (
            <FlipCard key={index} image={card.image} title={card.title} info={card.info} />
          ))}
        </div>
      </div>
    </>
  );
};

export default App;
